import React, { useState, useEffect } from "react";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import {Line} from 'react-chartjs-2';
import * as actions from "../store/actions";
import {connect} from "react-redux";
import moment from "moment/moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

//   export const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top' as const,
//       },
//       title: {
//         display: true,
//         text: 'Chart.js Line Chart',
//       },
//     },
//   };

function TotalsChart(props){

    const [labels, setLabels] = useState([]);
    const [myData, setMyData] = useState([]);
    const [trials, setTrials] = useState([]);

    useEffect(()=>{
        if (props.role === "admin"){
            props.onGetStatsChartAdmin(props.token);
        } else if (props.role === "manager"){
            props.onGetStatsChartSuperReseller(props.token);
        } else if (props.role === "reseller"){
            props.onGetStatsChartReseller(props.token);
        } else {
            props.onGetStatsChartDealer(props.token);
        }
        
        console.log('label', labels);
        console.log('mydata', myData);
        console.log('trials', trials);
    },[]);

    useEffect(() => {
        if (props.clients && props.clients.length){
            setLabels(props.labels);
            setMyData(props.clients);
            setTrials(props.trials);
            console.log('label', labels);
        console.log('mydata', myData);
        console.log('trials', trials);
        }
    },[props.clients]);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        //maintainAspectRatio : false,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Total Users History',
          },
        },
      };
    //   const data = {
    //     labels: labels,
    //     datasets: [
    //         {
    //             label: 'Active Users',
    //             fill: false,
    //             lineTension: 0.1,
    //             backgroundColor: 'rgba(75,192,192,0.4)',
    //             borderColor: 'rgba(75,192,192,1)',
    //             borderCapStyle: 'butt',
    //             borderDash: [],
    //             borderDashOffset: 0.0,
    //             borderJoinStyle: 'miter',
    //             pointBorderColor: 'rgba(75,192,192,1)',
    //             pointBackgroundColor: '#fff',
    //             pointBorderWidth: 1,
    //             pointHoverRadius: 5,
    //             pointHoverBackgroundColor: 'rgba(75,192,192,1)',
    //             pointHoverBorderColor: 'rgba(220,220,220,1)',
    //             pointHoverBorderWidth: 2,
    //             pointRadius: 1,
    //             pointHitRadius: 10,
    //             data: myData
    //         },
    //         {
    //             label: 'Trials',
    //             fill: false,
    //             lineTension: 0.1,
    //             backgroundColor: 'rgba(235,119,52, 0.4)',
    //             borderColor: 'rgba(235,119,60,1)',
    //             borderCapStyle: 'butt',
    //             borderDash: [],
    //             borderDashOffset: 0.0,
    //             borderJoinStyle: 'miter',
    //             pointBorderColor: 'rgba(75,192,192,1)',
    //             pointBackgroundColor: '#fff',
    //             pointBorderWidth: 1,
    //             pointHoverRadius: 5,
    //             pointHoverBackgroundColor: 'rgba(75,192,192,1)',
    //             pointHoverBorderColor: 'rgba(220,220,220,1)',
    //             pointHoverBorderWidth: 2,
    //             pointRadius: 1,
    //             pointHitRadius: 10,
    //             data: trials
    //         }
    //     ]
    // };
  
    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Active Users',
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                data: myData
            },
            {
                label: 'Trials',
                backgroundColor: 'rgba(235,119,52, 0.4)',
                borderColor: 'rgba(235,119,60,1)',
                data: trials
            }
        ]
    };

    return (
        <Card elevation={5}>
            <CardContent>
                <div style={{ position: "relative", margin: "0px", width: "99%" }}>
                    <Line options={options} data={data} />
                </div>
            </CardContent>
        </Card>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetStatsChartAdmin: (token) => dispatch(actions.getTotalStatsChartAdmin(token)),
        onGetStatsChartSuperReseller: (token) => dispatch(actions.getTotalStatsChartSuperReseller(token)),
        onGetStatsChartReseller: (token) => dispatch(actions.getTotalStatsChartReseller(token)),
        onGetStatsChartDealer: (token) => dispatch(actions.getTotalStatsChartDealer(token))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        //currentSuperResellerName: state.superReseller.name,
        labels: state.totalStats.on_date,
        clients: state.totalStats.clients,
        trials: state.totalStats.trials,
        //currentSuperReseller: state.superReseller.item,
        //isLoadingSuperReseller: state.superReseller.loading,
        //isErrorSaveSuperReseller: state.saveSuperReseller.error,
        //isSuccessSaveSuperReseller: state.saveSuperReseller.super_reseller,
        //isLoadingSaveSuperReseller: state.saveSuperReseller.loading
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TotalsChart);
